/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender user client side functions
-----------------------------------------------------------------------------*/

// The generic functions for Tender user side
var TECL_UserTenderGeneric = {

  // Reload the summary and change the sort order
  ChangeSummarySortOrder: function() {
    var tenderId = $("#TenderId").val();
    var sortTypeInt = $("#ddlTenderSummariesSortOrder").val();
    var showStatusControls = $("#tenderSupplierSummaryShowStatusControls").val();

    if (tenderId && sortTypeInt) {

      if (TECL_Master.AddLock("ChangeSummarySortOrder")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/ChangeTenderSummariesSortOrder",
          type: "POST",
          data: {
            tenderId: tenderId,
            sortTypeInt: sortTypeInt,
            showStatusControls: showStatusControls
          },
          error: function(exc) {
            TECL_Master.ClearLock("ChangeSummarySortOrder");
          },
          success: function(viewHtml) {
            TECL_Master.ClearLock("ChangeSummarySortOrder");
            if (viewHtml) {
              $("#tenderSummariesTable").html(viewHtml);
            }
          }
        });
      }
    }
  },

  // Display the file dowload dialog and show the case study file for the selected supplier
  DisplayCaseStudiesDownloadFiles: function(tenderSupplierId, supplierName) {
    if (tenderSupplierId && supplierName) {

      if (TECL_Master.AddLock("DisplayCaseStudiesDownloadFiles")) {
        TECL_TenderGeneral.DisplayPleaseWaitDlg();

        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/GetCaseStudiesDownloadFileDatas",
          type: "POST",
          data: {
            tenderSupplierId: tenderSupplierId,
            supplierName: supplierName
          },
          error: function(exc) {
            TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
            TECL_TenderGeneral.HidePleaseWaitDlg();
          },
          success: function(viewHtml) {
            TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
            TECL_TenderGeneral.HidePleaseWaitDlg();

            if (viewHtml) {
              $("#DownloadFilesDialog").empty().html(viewHtml);
              $("#tenderSupplierFileDownloadDialogData").modal("show");
            }
          }
        });
      }
    }
  },

  // Display the file dowload dialog and show the proposal file for the selected supplier
  DisplayProposalDownloadFilesDlg: function(tenderSupplierId, supplierName) {
    if (tenderSupplierId && supplierName) {

      if (TECL_Master.AddLock("DisplayProposalDownloadFilesDlg")) {
        TECL_TenderGeneral.DisplayPleaseWaitDlg();

        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/GetProposalDownloadFileDatas",
          type: "POST",
          data: {
            tenderSupplierId: tenderSupplierId,
            supplierName: supplierName
          },
          error: function(exc) {
            TECL_Master.ClearLock("DisplayProposalDownloadFilesDlg");
            TECL_TenderGeneral.HidePleaseWaitDlg();
          },
          success: function(viewHtml) {
            TECL_Master.ClearLock("DisplayProposalDownloadFilesDlg");
            TECL_TenderGeneral.HidePleaseWaitDlg();
            if (viewHtml) {
              $("#DownloadFilesDialog").empty().html(viewHtml);
              $("#tenderSupplierFileDownloadDialogData").modal("show");
            }
          }
        });
      }
    }
  },

  // Display the file dowload dialog and show the T&Cs file for the selected supplier
  DisplayTermsAndConditionsDownloadFilesDlg: function(tenderSupplierId, supplierName) {
    if (tenderSupplierId && supplierName) {

      if (TECL_Master.AddLock("DisplayCaseStudiesDownloadFiles")) {
        TECL_TenderGeneral.DisplayPleaseWaitDlg();

        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/GetTermsAndConditionDownloadFileDatas",
          type: "POST",
          data: {
            tenderSupplierId: tenderSupplierId,
            supplierName: supplierName
          },
          error: function(exc) {
            TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
            TECL_TenderGeneral.HidePleaseWaitDlg();
          },
          success: function(viewHtml) {
            TECL_Master.ClearLock("DisplayCaseStudiesDownloadFiles");
            TECL_TenderGeneral.HidePleaseWaitDlg();

            if (viewHtml) {
              $("#DownloadFilesDialog").empty().html(viewHtml);
              $("#tenderSupplierFileDownloadDialogData").modal("show");
            }
          }
        });
      }
    }
  },

  // Setup the new tender and call the page
  CreateNewTender: function() {
    if (TECL_Master.AddLock("CreateNewTender")) {
      $.ajax({
        url: baseSiteUrl + "TenderUserSurface/CreateNewTender",
        dataType: "json",
        type: "POST",
        data: {
        },
        error: function(exc) {
          TECL_Master.ClearLock("CreateNewTender");
        },
        success: function(redirectUrl) {
          TECL_Master.ClearLock("CreateNewTender");
          if (redirectUrl) {
            window.location = redirectUrl;
          }
        }
      });
    }
  },

  // The active tenders tab has been selected
  ActiveTendersSelected: function() {
    TECL_UserTenderGeneric.ChangePanelDisplay("activeChallengesPnl", "activeChallengesBtn", "activeTendersPnl", "activeTendersBtn");
  },

  // The active challenges tab has been selected
  ActiveChallengesSelected: function() {
    TECL_UserTenderGeneric.ChangePanelDisplay("activeTendersPnl", "activeTendersBtn", "activeChallengesPnl", "activeChallengesBtn");
  },

  // The historic tenders tab has been selected
  HistoricTendersSelected: function() {
    TECL_UserTenderGeneric.ChangePanelDisplay("historicalChallengesPnl", "historicalChallengesBtn", "historicalTendersPnl", "historicalTendersBtn");
  },

  // The historic challenges tab has been selected
  HistoricChallengesSelected: function() {
    TECL_UserTenderGeneric.ChangePanelDisplay("historicalTendersPnl", "historicalTendersBtn", "historicalChallengesPnl", "historicalChallengesBtn");
  },

  // Change the display state of panels
  ChangePanelDisplay: function(hidePanelId, hideButtonId, showPanelId, showButtonId) {

    $("#" + hidePanelId).fadeOut();
    $("#" + hidePanelId).addClass("hidden");

    $("#" + showPanelId).fadeIn(1000);
    $("#" + showPanelId).removeClass("hidden");

    $("#" + showButtonId).addClass("selected");
    $("#" + hideButtonId).removeClass("selected");
  },
  
  // Cancel the entire tender
  CancelTender: function(tenderId) {

    if (TECL_Master.AddLock("TECL_SupplierRejection_CancelTender")) {
      $.ajax({
        url: baseSiteUrl + "TenderUserSurface/CancelTender",
        type: "POST",
        data: {
          tenderId: tenderId
        },
        error: function() {
          TECL_Master.ClearLock("TECL_SupplierRejection_CancelTender");
          TECL_Master.ShowErrorDialog();
        },
        success: function(data) {
          TECL_Master.ClearLock("TECL_SupplierRejection_CancelTender");

          if (data && data.Cancelled && data.RedirectionUrl) {
            window.location.href = data.RedirectionUrl;
          } else {
            TECL_Master.ShowErrorDialog(data.ErrorMessage);
          }
        }
      });
    }
  },

  // Display the cancellation check dialog
  DisplayCancellationCheckDialog: function(tenderId) {
    if (TECL_Master.AddLock("TECL_SupplierRejection_DisplayCancellationCheckDialog")) {
      $.ajax({
        url: baseSiteUrl + "TenderUserSurface/GetCancellationCheckDialog",
        type: "POST",
        data: {
          tenderId: tenderId
        },
        error: function() {
          TECL_Master.ClearLock("TECL_SupplierRejection_DisplayCancellationCheckDialog");
          TECL_Master.ShowErrorDialog();
        },
        success: function(view) {
          TECL_Master.ClearLock("TECL_SupplierRejection_DisplayCancellationCheckDialog");

          if (view) {
            $("#cancellationCheckDialogDiv").html(view);
            $("#cancellationCheckDialog").modal("show");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  }
  
};
